export default "__VITE_ASSET__ae30a98b__"